import styled from '@emotion/styled';
import { Popover as ReakitPopover, PopoverArrow } from 'reakit/Popover';
import { OL_COLOUR_BLACK_10 } from '../Style/colours';
import { POPOVER_Z_INDEX } from '../Style/zindex';

export const StyledPopover = styled(ReakitPopover)({
  background: 'white',
  borderRadius: '4px',
  boxShadow: ' 0px 4px 10px rgba(0, 0, 0, 0.15)',
  border: `1px solid ${OL_COLOUR_BLACK_10}`,
  zIndex: POPOVER_Z_INDEX,
});

export const StyledPopoverArrow = styled(PopoverArrow)({
  '.stroke': {
    fill: OL_COLOUR_BLACK_10,
  },
  '.fill': {
    fill: 'white',
  },
});
